<template>
  <hc-maybay-state
    v-if="hcFlowInstance"
    :state="hcFlowInstance.currentStateCode"
  />
</template>

<script>
  import hcCaseMasterService from "../../../services/hcCaseMasterService";
  import hcFlowInstanceService from "../../../services/hcFlowInstanceService";
  import HcMaybayState from "../khachsan/hc-maybay-state";

  export default {
    name: "hc-case-calendar-phonghop-state",
    components: {HcMaybayState},
    props: ["hcCaseMasterId"],

    data() {
      return {
        hcCaseMaster: null,
        hcFlowInstance: null,
      }
    },

    watch: {
      hcCaseMasterId() {
        this.initComponent();
      }
    },

    async created() {
      await this.initComponent();
    },

    methods: {

      async initComponent() {
        await this.loadHcCaseMaster();
        await this.loadHcFlowInstance();
      },

      loadHcCaseMaster() {
        return hcCaseMasterService
          .findById(this.hcCaseMasterId)
          .then(response => (this.hcCaseMaster = response.data));
      },

      loadHcFlowInstance() {
        return hcFlowInstanceService
          .findById(this.hcCaseMaster.flowInstanceId)
          .then(response => (this.hcFlowInstance = response.data));
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/hc-case-calendar-phonghop-state.vue